import { axios, transformAxiosError } from "../utils/axios.create";
import {
  EducationalResource,
  EducationalResourcePayload,
} from "../domain/educationalResources.interface";

export type EducationalResourcesFindAllPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status: string;
  type: string;
  categoryId: string;
  language: string;
};

const findAll = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
  type,
  categoryId,
  language,
}: EducationalResourcesFindAllPayload): Promise<{
  list: EducationalResource[];
  totalCount: number;
}> => {
  const queryParams = new URLSearchParams({
    search,
    status,
    type,
    categoryId,
    language,
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/educational-resources/search?${queryParams.toString()}`)
    .then((res) => ({
      list: res.data.body.list as EducationalResource[],
      totalCount: res.data.body.totalCount as number,
    }))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const createOne = async (
  payload: EducationalResourcePayload
): Promise<EducationalResource> => {
  return axios
    .post("/educational-resources", payload)
    .then((res) => res.data.body as EducationalResource)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const updateOne = async ({
  id,
  payload,
}: {
  id: string;
  payload: EducationalResourcePayload;
}): Promise<EducationalResource> => {
  return axios
    .put(`/educational-resources/${id}`, payload)
    .then((res) => res.data.body as EducationalResource)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/educational-resources/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const EducationalResourcesService = {
  findAll,
  createOne,
  updateOne,
  archiveOne,
};
